<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Orientação"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :maxlength="validations.descricao.max"
                        :validations="validations.descricao"
                        name="Orientação"
                        rows="4"
                        v-model="model.descricao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                descricao: {
                    required: true,
                    max: 5000,
                },
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            descricao: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({descricao: this.item.descricao})
        },
        store() {
            this.data.model.orientacoes.push({descricao: this.model.descricao})
        },
        update() {
            Object.assign(this.item, {descricao: this.model.descricao})
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.descricao = null
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
}
</script>